import React from "react";

const Loader = (props) => {
  return (
    <div
      className={`${props.align ?? "text-center"} relative z-[1] leading-none ${
        props.class ?? ""
      }`}
    >
      <div className={`loader ${props.loaderClass ?? ""}`}></div>
    </div>
  );
};

export default Loader;
